export class BookingVersionError extends Error {
  constructor(message = 'Error getting booking version') {
    super(message);
    this.name = 'BookingVersionError';
  }
}
